import { ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useModalContext } from "@hooks/contexts/modal-context";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { ModalInfoHtml } from "../modal-info/indexHtml";
import { api } from "@service/api";
import { IRaffleTypeDTO } from "@hooks/dtos/raffles/IRaffleTypeDTO";
import parse from "html-react-parser";

interface IProps {
  typeId: number;
  onClose: () => void;
}

export function ModalRaffleType({ typeId, onClose }: IProps) {
  // Default Variables
  const location = useLocation();
  const { changeHash } = useModalContext();
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [raffleType, setRaffleType] = useState<IRaffleTypeDTO>();

  async function getModalInfo() {
    try {
      const params = `?typeId=${typeId}`;
      const response = await api.get(`/raffle/type${params}`);

      setRaffleType(response.data);

      setIsLoading(false);
    } catch (error: any) {
      pushToastify({
        message:
          error?.response?.data?.message || "Falha ao carregar informações.",
        type: "error",
        theme: "dark",
      });
    }

    OpenModal();
  }

  function OpenModal() {
    changeHash("modalInfo");
  }

  useEffect(() => {
    getModalInfo();
  }, [location.hash, typeId]);

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      <ModalInfoHtml
        header={raffleType?.name || "Erro ao carregar cabeçalho."}
        title={raffleType?.description_short || "Erro ao carregar cabeçalho."}
        html={raffleType?.description ? parse(raffleType.description) : ""}
        isOpen={location?.hash === "#modalInfo"}
        onClose={() => {
          changeHash("");
          onClose();
        }}
      />
    </>
  );
}
